<template>
	<div @click="$emit('show_course', course, $event)" class="k-main-collection-item k-cv-lp-tile" :class="lp_css" :style="U.collection_color_style(lp,false)">
		<div class="k-cv-lp-tile__title" :style="lp_css_color">
			<div class="k-cv-lp-tile__title-title" :style="`color:${U.get_contrast_color(lp.color)}`"><div>
				<k-icon style="font-size:20px; margin-right:4px;" :color="U.get_contrast_color(lp.color)">{{lp.collection_icon()}}</k-icon><span v-html="lp_title"></span>
			</div></div>

			<!-- special note for sandbox when showing the chooser -->
			<div v-if="lti_chooser && course.lp_id==1" class="k-lti-chooser-top-option-note">All activities you’ve created or edited yourself</div>

			<div v-if="teacher_name" class="k-cv-lp-tile__title-teacher">{{ teacher_name }}</div>
		</div>
		<div class="k-cv-lp-tile-message-count"
			v-if="unread_messages && (!course || !course.viewing_origin_teacher_activities)">
			<k-tooltip bottom>
				<template v-slot:activator="{ on }">
					<k-icon v-on="on" color="white">far fa-comment</k-icon>
					<div v-on="on" class="k-cv-lp-tile-message-count-text">{{ unread_messages }}</div>
				</template>
				<span v-html="unread_messages_tooltip"></span>
			</k-tooltip>
		</div>
		<div class="k-cv-lp-tile-activity-count"
			v-if="activity_count &&  (!course || !course.viewing_origin_teacher_activities)">
			<k-tooltip bottom>
				<template v-slot:activator="{ on }">
					<div v-on="on" class="k-cvlp-unit__status white">{{ activity_count }}</div>
				</template>
				<span v-html="activity_count_tooltip"></span>
			</k-tooltip>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	components: { },
	props: {
		course: { type: Object, required: true },
		course_showing: { type: String, required: true },
		welcome_section_collection_types: { type: Array, required: true },
	},
	data() { return {
	}},
	computed: {
		...mapState(['user_info', 'all_courses', 'messages', 'my_activities', 'my_activity_results', 'term_settings']),
		...mapGetters(['studentish_role', 'manage_assignments', 'lti_chooser']),
		teacher_name() {
			if (!this.studentish_role) return ''
			let teacher = this.course?.teachers?.slice(0, 1)?.pop() ?? null
			if (!teacher) return ''

			// we may receive course info for multiple terms and teachers
			// Henry IC
			let current_term = vapp.$store.getters.current_term
			if ($.isArray(this.course.course_sourcedIds) && this.course.teachers.length == 2) {
				if (current_term == 1 || current_term == 2) {
					teacher = this.course.teachers[0]
				} else if (current_term == 3 || current_term == 4) {
					teacher = this.course.teachers[1]
				}
			}

			// complex IC structure may require this:
			if ($.isArray(teacher)) teacher = teacher[0]

			if (teacher.familyName && teacher.givenName) return `${teacher.familyName}, ${teacher.givenName}${teacher.middleName ? ' ' + teacher.middleName : ''}`
			return ''
		},
		lp_css() {
			let s = ''
			if (this.course_showing) s += ' k-cv-lp-tile--course_showing'
			if (this.course_showing == this.course.course_code) s += ' k-cv-lp-tile--this_course_showing'
			// add a style determined by whether or not we're viewing the "tab" for the collection_type of this LP
			if (this.welcome_section_collection_types.includes(this.lp.collection_type)) {
				s += ' k-cv-lp-tile--in-welcome-section'
			} else {
				s += ' k-cv-lp-tile--not-in-welcome-section'
			}

			// this logic is in other places too; it would probably be better to centralize this...
			if (!empty(this.lp?.title)) {
				if (this.lp.title.length > 50 || U.longest_word_length(this.lp.title) > 18) {
					s += ' k-lp-tile-extra-long-title'
				} else if (this.lp.title.length > 30 || U.longest_word_length(this.lp.title) > 12) {
					s += ' k-lp-tile-long-title'
				}
			}

			if (this.lp.active == 'no') s += ' k-cv-lp-tile--not-active'
			// legacy from old assignment system
			// s += ' k-cv-lp-tile--no-asns'
			return s
		},
		lp_css_color() {
			return U.collection_color_style(this.lp)
		},
		lp() {
			return this.all_courses.find(c=>c.course_code == this.course.course_code)
		},
		lp_title() {
			let s = ''
			// add <wbr> tags after slashes
			s += this.lp.title.replace(/\//g, '/<wbr>')
			return s
		},
		unread_messages() {
			let n = 0
			for (let message of this.messages) {
				if (message.course_code !== this.course.course_code) continue
				if (!message.is_read && message.message_id !== 0) ++n
			}
			return n
		},
		unread_messages_tooltip() {
			return sr('$1 unread $2', this.unread_messages, U.ps('message', this.unread_messages, 'messages'))
		},
		activity_count() {
			if (!this.manage_assignments) return 0
			let n = 0
			for (let activity of this.my_activities) {
				if (activity.course_code == this.course.course_code) {
					// for students, don't count complete activities or activities that aren't available
					if (this.studentish_role) {
						if (this.my_activity_results[activity.activity_id]?.complete() || !activity.available_to_students()) {
							continue
						}
						// for teachers, only count currently due activities that I've created
					} else {
						if (activity.creator_user_id != this.user_info.user_id) continue
						if (!activity.currently_due()) continue
					}
					++n
				}
			}
			return n
		},
		activity_count_tooltip() {
			if (this.studentish_role) {
				return sr('$1 incomplete $2', this.activity_count, U.ps('activity', this.activity_count, 'activities'))
			} else {
				return sr('$1 $2 currently available and due', this.activity_count, U.ps('activity', this.activity_count, 'activities'))
			}
		},
	},
	created() {
	},
	mounted() {
	},
	methods: {

	}
}
</script>

<style lang="scss">

.k-main-wrapper .k-main-collection-item.k-cv-lp-tile {
	width:190px;
	height:190px;
	border-radius:35px;
	text-align:left;
	padding:0;
	// margin:12px;
	flex-direction: row;
	align-items: center;
	// background-color:rgba(255,255,255, 0);

	.k-cv-lp-tile__title {
		flex:1 1 190px;
		display:flex;
		flex-direction: column;
		justify-content: space-around;
		height:190px;
		border-radius:35px;
		font-size:22px;
		line-height:26px;
		font-weight:bold;
		color:#fff;
		// color:#444;
		padding:15px;

		.k-cv-lp-tile__title-teacher {
			font-size:12px;
			line-height:15px;
			font-weight:normal;
			padding-top:4px;
		}
	}

	.k-cv-lp-tile-message-count {
		position: absolute;
		left: 12px;
		bottom: 11px;

		>.v-icon {
			font-size: 24px;
			transform: scaleX(0.85) // this makes it so the bubble is a circle
		}

		.k-cv-lp-tile-message-count-text {
			position: absolute;
			display: inline-block;
			font-size: 12px;
			left: 0;
			right: 0;
			text-align: center;
			font-weight: 900;
			color: #fff;
		}
	}

	.k-cv-lp-tile-activity-count {
		position: absolute;
		right: 12px;
		bottom: 11px;

		.k-cvlp-unit__status {
			display: inline-block;
			font-size: 12px;
			width: 24px;
			height: 24px;
			line-height: 24px;
			border-radius: 24px;
			text-align: center;
			font-weight: 900;
			margin: 0 1px;
		}
	}
}

.k-main-wrapper .k-main-collection-item.k-cv-lp-tile--course_showing {
	width:100px;
	height:100px;
	min-width:100px;
	border-radius:16px;
	opacity:0.6;
	margin:10px;
	background-color:#f8f8f8;
	-webkit-box-shadow: 0 0 0 0 !important;
    box-shadow: 0 0 0 0 !important;

	.k-cv-lp-tile__title {
		flex:1 1 100px;
		height:100px;
		border-radius:16px;
		font-weight:normal;
		font-size:12px;
		line-height:14px;
		padding:8px;
	}

}

.k-main-wrapper .k-main-collection-item.k-cv-lp-tile--this_course_showing {
	font-weight:bold;
	background-color:#eee;
	opacity:1.0;
	-webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12) !important;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12) !important;

	.k-cv-lp-tile__title {
		font-weight:bold;
	}
}

.k-cv-lp-tile-caught-up {
	color:#555;
}

.k-cv-lp-tile--in-welcome-section {
	// border:3px solid #000;
}
.k-cv-lp-tile--not-in-welcome-section {
	opacity:0.3;
	box-shadow:none!important;
}

.k-cv-lp-tile--not-active {
	.k-cv-lp-tile__title {
		border: 3px dashed #ccc;
	}
}

.k-main-collection-item.k-cv-lp-tile.k-lp-tile-long-title .k-cv-lp-tile__title{
	font-size: 17px!important;
	line-height: 20px!important;
}

.k-main-collection-item.k-cv-lp-tile.k-lp-tile-extra-long-title .k-cv-lp-tile__title{
	font-size: 15px!important;
	line-height: 18px!important;
}

</style>
